import UgcConfirmDesign from "./ConfirmDesign";

export default UgcConfirmDesign;
